"use strict";

var _regeneratorRuntime = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/cex/Desktop/burnsignal/burnsignal-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ethers = __importStar(require("ethers"));

var AuthereumSDK_1 = __importDefault(require("./AuthereumSDK"));

var AuthereumSigner =
/*#__PURE__*/
function (_ethers$Signer) {
  _inherits(AuthereumSigner, _ethers$Signer);

  function AuthereumSigner(config) {
    var _this;

    _classCallCheck(this, AuthereumSigner);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AuthereumSigner).call(this));
    _this.config = config || {};
    _this.authereum = new AuthereumSDK_1.default(_this.config);
    _this.provider = new ethers.providers.JsonRpcProvider(_this.authereum.getRpcUri());
    return _this;
  }

  _createClass(AuthereumSigner, [{
    key: "getAddress",
    value: function getAddress() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.authereum.getAccountAddress());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "signMessage",
    value: function signMessage(message) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.authereum.signWithDappKey(message));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "sendTransaction",
    value: function sendTransaction(transaction) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var signedTx;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.sign(transaction);

              case 2:
                signedTx = _context3.sent;
                return _context3.abrupt("return", this.provider.sendTransaction(signedTx));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "sign",
    value: function sign(transaction) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var tx, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.fillInTxExtras(transaction);

              case 2:
                transaction = _context4.sent;
                _context4.next = 5;
                return ethers.utils.resolveProperties(transaction);

              case 5:
                tx = _context4.sent;
                _context4.next = 8;
                return this.authereum.signTransactionWithLoginKey(tx);

              case 8:
                res = _context4.sent;
                return _context4.abrupt("return", res.signedTransactionData);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "fillInTxExtras",
    value: function fillInTxExtras(tx) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var gas, gasPrice;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (tx.gas) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 3;
                return this.provider.estimateGas(tx);

              case 3:
                gas = _context5.sent;
                tx.gas = gas.toString();

              case 5:
                if (tx.gasPrice) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 8;
                return this.provider.getGasPrice();

              case 8:
                gasPrice = _context5.sent;
                tx.gasPrice = gasPrice.toString();

              case 10:
                // TODO: best practices for min gas (21000)
                if (tx.gas === '21000') {
                  tx.gas = "500000";
                }

                if (tx.gas && typeof tx.gas !== 'string') {
                  tx.gas = tx.gas.toString();
                }

                if (tx.gasPrice && typeof tx.gasPrice !== 'string') {
                  tx.gasPrice = tx.gasPrice.toString();
                }

                if (tx.value && typeof tx.value !== 'string') {
                  tx.value = tx.value.toString();
                }

                return _context5.abrupt("return", tx);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return AuthereumSigner;
}(ethers.Signer);

exports.default = AuthereumSigner;